import { takeEvery } from 'redux-saga';
import { all, call, take, put, select } from 'redux-saga/effects';
import { postJSON } from '../util';

let submitting = false; // TODO: Why doesn't 'state.product.submitting' work?

export function* init({ payload }) {
    yield all([
        put({ type: 'price:required', payload: payload.upc }),
        put({ type: 'product:teeup' }), /* trigger for cordial */
    ]);
}

export function* submit({ payload }) {
    const user = yield select(state => state.user);
    const submitting_prod = yield select(state => state.product.submitting);

    if (!user.logged_in) {
        yield all([
            put({ type: 'route:to', payload: 'login' }),
            take('user:logged-in'),
        ]);
    }

    if (submitting_prod || submitting) {
        return;
    }

    submitting = true;

    yield put({ type: 'product:submitting', payload: true });

    const upc = yield select(state => state.product.description.code);

    try {
        const order = yield call(postJSON, `/api/product/submit/${upc}`, JSON.stringify(payload));

        yield put({ type: 'location:href', payload: order.forwarding_url });
    } catch(e) {
        yield put({ type: 'tarot-reading:loaded', error: e });
    }
}

export function* root() {
    yield* [
        takeEvery('i-ching-reading:init', init),
        takeEvery('i-ching-reading:submit', submit),
    ];
}



// WEBPACK FOOTER //
// ./app/sagas/i-ching-reading.js